import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id C36FCD4A-D073-4BCA-96D1-90CD81E4C080
 * name boxing-glove
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boxing-glove.svg
 * tags
 * - Sport 
 */
export const BoxingGloveIcon = createSvgIcon(<><path d="M19,16V6H22V16H19M12,4C8,4 7,4 7,4C7,4 2,4 2,8V14C2,15.77 3,16.76 4.07,17.31C4.4,15.43 6.03,14 8,14H11V16H8A2,2 0 0,0 6,18C6,19.11 6.9,20 8,20H13C17,20 17,16 17,16V6C17,6 16,4 12,4Z" /></>, 'BoxingGloveIcon');
export default BoxingGloveIcon